import Textarea from './ui/Textarea'
import { useState } from 'react'

// Keep keystrokes local while making the current text available to Save immediately.
export default function DraftTextarea({ initialValue = '', draftRef, ...props }) {
    const [draft, setDraft] = useState(initialValue)
    return <Textarea {...props} value={draft} onChange={event => {
        const next = event.target.value
        draftRef.current = next
        setDraft(next)
    }} />
}
